export const CustomerIconV2 = ({ width = "46" }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="0.5" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <path
        d="M26.2725 31.7275C30.6907 31.7275 34.2725 28.1458 34.2725 23.7275C34.2725 19.3093 30.6907 15.7275 26.2725 15.7275C21.8542 15.7275 18.2725 19.3093 18.2725 23.7275C18.2725 28.1458 21.8542 31.7275 26.2725 31.7275Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2725 51.7275V43.7275C12.2725 41.5183 14.0633 39.7275 16.2725 39.7275H36.2725C38.4817 39.7275 40.2725 41.5183 40.2725 43.7275V51.7275"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.2725 15.7275C41.9933 16.1681 43.5185 17.1689 44.6077 18.5722C45.6969 19.9754 46.2881 21.7012 46.2881 23.4775C46.2881 25.2539 45.6969 26.9797 44.6077 28.3829C43.5185 29.7861 41.9933 30.7869 40.2725 31.2275"
        stroke="#696677"
        strokeWidth="1.45455"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2725 39.7275H48.2725C50.4817 39.7275 52.2725 41.5183 52.2725 43.7275V51.7275"
        stroke="#696677"
        strokeWidth="1.45455"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
